<div
  routerLink="/defuse"
  class="upgrade-banner group relative flex h-[25.6rem] w-[28.8rem] cursor-pointer rounded-[2.4rem] bg-[linear-gradient(359deg,#BC0C23_6.98%,#601819_108.76%)] custom-transition-bg before:rounded-[2.4rem] before:bg-[linear-gradient(359deg,#D0152E_6.98%,#762021_108.76%)] lg:rounded-[1.4rem] lg:w-full lg:h-[16.2rem]"
>
  <div class="relative h-full w-full overflow-hidden rounded-[2.4rem] p-[2.4rem] lg:rounded-[1.4rem] lg:p-[1.6rem]">
    <div class="flex h-full flex-col justify-between">
      <span class="text-[2rem] font-450 leading-[2.6rem] text-white lg:text-[1.5rem] lg:leadfing-[2.2rem]">Defuse</span>
      <button
        class="flex h-[3rem] w-[5rem] items-center justify-center rounded-[1rem] bg-[#FFAFA5] opacity-80 custom-transition-all group-hover:w-[5.6rem] group-hover:bg-[#FFBFB7] lg:h-[2.6rem] lg:w-[3.8rem] lg:rounded-[0.8rem]"
      >
        <i class="icon icon_arrow-right-alt text-[2.4rem] !text-dark-250 lg:text-[1.8rem]"></i>
      </button>
    </div>
    <div class="upgrade-shadow"></div>
  </div>
  <div class="upgrade-defuse"></div>
</div>
